'use client';

import { useEffect } from 'react';
import { supabaseClient } from '@/lib/supabase/client';

const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

function isBackendApiRequest(input: RequestInfo | URL) {
  const requestUrl = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
  return requestUrl.startsWith(apiBaseUrl);
}

/** Attaches the current Supabase access token to this application's backend calls only. */
export function useApiAuthorization() {
  useEffect(() => {
    const originalFetch = window.fetch.bind(window);
    window.fetch = async (input, init) => {
      if (!isBackendApiRequest(input)) return originalFetch(input, init);
      const { data } = await supabaseClient.auth.getSession();
      const accessToken = data.session?.access_token;
      if (!accessToken) return originalFetch(input, init);

      const headers = new Headers(input instanceof Request ? input.headers : undefined);
      new Headers(init?.headers).forEach((value, key) => headers.set(key, value));
      headers.set('Authorization', `Bearer ${accessToken}`);
      return originalFetch(input, { ...init, headers });
    };
    return () => { window.fetch = originalFetch; };
  }, []);
}
